export default "__VITE_ASSET__fIGNv_pS__"